import styled from 'styled-components';
import { mediaQuery } from '@carvana/showroom-css-theme';
import SecondaryButton from '@carvana/showroom-forms/Button/Secondary';
import CommonAccordion from '../_common/accordion/Accordion';

export const ASRCardWrapper = styled.div<any>`
  max-width: 912px;
  background: #ffffff;
  border: 1px solid #d9dde9;
  box-sizing: border-box;
  box-shadow: 0px 2px 3px rgba(24, 53, 88, 0.1);
  border-radius: 8px;
  margin: 0 auto;
  overflow: hidden;
  padding: 24px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  gap: 24px;
`;

export const MainContentWrapper = styled.div<any>`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  gap: 24px;

  ${mediaQuery('m')} {
    flex-direction: row;
    align-items: center;
  }
`;

export const ContentWrapper = styled.div<any>`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Button = styled(SecondaryButton)`
  margin: 0;
  min-height: 40px;
  word-break: break-word;
  padding: 0 24px;
  align-self: flex-end;
  width: 100%;
  text-transform: uppercase;
  width: 100%;

  ${mediaQuery('m')} {
    width: 200px;
  }
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  > p {
    color: var(--cvna-color-grey-5);
  }

  ${mediaQuery('m')} {
    margin-right: 34px;
  }
`;

export const Text = styled.p<any>`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: var(--cvna-color-blue-6);
  margin: 0;
`;

export const ViewWarrantyCard = styled.span<any>`
  color: #00aed9;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export const SubText = styled(Text)<any>`
  margin-top: 12px;
`;

export const FootNoteWrapper = styled.div<any>`
  padding: 0;
`;

export const Note = styled.p<any>`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #757989;
  margin-bottom: 0;
  padding: 16px 0 0;
`;

export const HR = styled.hr<any>`
  border-color: transparent;
  border-top: 1px solid #d9dde9;
  margin: 0;
`;

export const ConcernsWrapper = styled.div<any>`
  font-size: 14px;
  line-height: 20px;

  & [data-qa='accordion'] {
    padding: 16px 0;
  }

  &:last-of-type [data-qa='accordion'] {
    padding-bottom: 0;
  }
`;

export const ConcernList = styled.ul<any>`
  list-style: none;
  margin: 0;
  padding: 10px 0 0;
`;

export const ConcernListItem = styled.li<any>`
  display: flex;
  color: #183558;
  align-items: center;
  justify-content: space-between;
  padding: 18px 14px;
  background: #f4f8fa;
  border-radius: 4px;
  height: 52px;
  font-weight: 390;
  font-size: 12px;
  line-height: 16px;
  font-feature-settings: 'pnum' on, 'lnum' on, 'liga' off;
  margin-bottom: 16px;
  cursor: pointer;

  &:last-of-type {
    margin-bottom: 0;
  }

  & [data-qa='chevron-icon'] {
    transform: rotate(-90deg);
  }
`;

export const Accordion = styled(CommonAccordion)<any>`
  > div {
    padding: 16px 0 0;

    h4 {
      color: var(--cvna-color-blue-6);
    }
  }
`;

export const ModalContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 8px 16px;
  height: calc(100vh - 96px);

  ${mediaQuery('m')} {
    height: auto;
    max-width: 327px;
    margin: 0 auto;
    padding: 24px 0;
  }
`;